import React, { useState, useEffect } from 'react';
import { Image } from '@thd-olt-component-react/image';
import classNames from 'classnames/bind';
import { string } from 'prop-types';
import {
  params,
  shape,
  string as stringType,
  useDataModel,
  arrayOf as arrayType
} from '@thd-nucleus/data-sources';

import styles from './related-articles.module.scss';

const RelatedArticles = ({ articleGUID }) => {
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('related-articles.ready'); }, []);

  const { data, loading, error } = useDataModel('article', {
    variables: { articleGUID },
  });

  if (!data || loading || error) {
    return null;
  }

  const relatedArticles = data?.article?.relatedArticles;

  if (!Array.isArray(relatedArticles) || !relatedArticles.length) {
    return null;
  }

  const relatedArticlesItem = (relatedArticle, i) => {
    return (
      <div className={styles.related_articles__link_wrapper} key={`tile-${i}`}>
        <a href={relatedArticle?.url} className={styles.related_articles__link}>
          {/* eslint-disable-next-line max-len */}
          <div className={styles.related_articles__image_wrapper}>
            <Image
              className={styles.related_articles__image}
              src={relatedArticle?.imageURL}
              alt={relatedArticle?.title}
              width={1}
              height={1}
              lazy
            />
          </div>
          <span className={styles.related_articles__content}>{relatedArticle?.title}</span>
        </a>
      </div>
    );
  };

  return (
    <div data-testid="related-articles" className={styles.related_articles__pod}>
      <h2 className={styles.related_articles__heading}>Related Guides</h2>
      <div className={styles.related_articles__items}>
        {relatedArticles.map((relatedArticle, i) => relatedArticlesItem(relatedArticle, i))}
      </div>
    </div>
  );
};

RelatedArticles.propTypes = {
  articleGUID: string.isRequired,
};

RelatedArticles.displayName = 'RelatedArticles';

RelatedArticles.dataModel = {
  article: params({ articleGUID: stringType().isRequired() }).shape({
    relatedArticles: arrayType(shape({
      title: stringType(),
      url: stringType(),
      imageURL: stringType()
    }))
  }),
};

export { RelatedArticles };
